<div class="dialog-body">
  <div class="dialog-header border-bottom p-3">
    <h3 class="dialog-title fs-5 m-0 fw-medium">{{header}}</h3>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="p-3 modal-body modal-height">
    <p [innerHTML]="content | safeHtml"></p>
  </div>
</div>